<template>
  <section>
    <loader ref="loader" />
    <Form @submit="signInContinue">
      <div class="cs-sign-in__inputs">
        <text-input
          name="email"
          id="email"
          v-model:value="email"
          :placeholder="$t('sign-in.email')"
          ref="email"
          :schema="emailSchema"
          autocomplete="email"
        />
      </div>
      <div class="cs-sign-in__toggle cs-sign-in__toggle--inputs mt-3 mb-3">
        <button
          type="button"
          class="cs-sign-in__toggle-btn"
          :class="{ 'is-active': isPasswordMode }"
          @click="$emit('change-mode', 'password')"
        >
          {{ $t("sign-in.use-password") }}
        </button>
        <button
          type="button"
          class="cs-sign-in__toggle-btn"
          :class="{ 'is-active': !isPasswordMode }"
          @click="$emit('change-mode', 'magic')"
        >
          {{ $t("sign-in.send-verification-code") }}
        </button>
      </div>
      <small class="cs-sign-in__error" v-if="error">
        {{ error }}
      </small>
      <CustomButton
        className="cs-sign-in__primary button-default"
        type="submit"
        :name="submitLabel"
      />
    </Form>
    <div v-if="!compact" class="sign-up-text mt-3">
      or
      <span @click="doSigin()" class="sign-up-btn cursor-pointer">
        {{ $t("magic-link.loginWithPass") }}
      </span>
    </div>
    <div v-if="!compact" class="sign-up-text">
      {{ changePartnerLabelName(marketInfo, "sign-in.no-account") }}
      <span @click="doSignUp()" class="sign-up-btn cursor-pointer">
        {{ $t("sign-in.sign-up") }}
      </span>
    </div>
  </section>
</template>

<script>
import { Magic } from "magic-sdk";
import { mapGetters } from "vuex";
import { GET_USER_INFO, USER_TRACK_EVENTS } from "@/store/modules/user/consts";
import CustomButton from "../views/customButton.vue";
import * as Yup from "yup";
import { extractCartEmail, persistCartEmail } from "@/utils/cartEmail";
import getRecaptchaToken from '@/utils/recaptcha';
export default {
  data() {
    return {
      popup: null,
      email: this.$store.getters["auth/userEmail"] || "",
      oneTimePass: null,
      error: "",
      m: new Magic(process.env.VUE_APP_MAGIC_PUBLISHABLE_KEY),
    };
  },
  props: {
    offMagic: {
      type: Function,
      default: (val) => {},
    },
    submitLabel: {
      type: String,
      default: "Continue with email",
    },
    compact: {
      type: Boolean,
      default: false,
    },
    isPasswordMode: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["change-mode"],
  computed: {
    ...mapGetters({
      marketInfo: "user/marketInfo",
      cart: "user/cart",
      userEmail: "auth/userEmail",
    }),
  },
  setup() {
    const emailSchema = Yup.string().email().required();
    return { emailSchema };
  },
  components: {
    CustomButton,
  },
  watch: {
    email(newVal) {
      if (newVal) {
        this.error = "";
      }
    },
    userEmail: {
      handler(val) {
        if (val) {
          this.email = val;
        }
      },
      immediate: true,
    },
    cart: {
      handler(val) {
        if (!val || !Object.keys(val).length) {
          return;
        }
        persistCartEmail(this.$store, val);
        this.syncEmailFromCart();
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    syncEmailFromCart() {
      const email =
        this.$store.getters["auth/userEmail"] || extractCartEmail(this.cart);
      if (email) {
        this.email = email;
      }
    },
    doSignUp() {
      this.$router.push({
        name: "SignUp",
      });
    },
    async magicSIGN(token) {
      this.error = ""; // Clear any previous errors
      this.$nextTick(async () => {
        try {
          const encryptedReq = this.encryptStringWithRSA(
            JSON.stringify({
              email: this.email.toLowerCase(),
              // password: 'Test@123',
            })
          );
          await this.$store.dispatch("auth/magicSIGN", {
            encryptedReq,
            token,
            recaptcha: await getRecaptchaToken(this),
          });
          const info = await this.$store.dispatch(`user/${GET_USER_INFO}`);
          if (info.type === 1 || info.type === 5) {
            //merchant or payout admin
            if (this.popup) {
              this.popup.focus();
              this.popup.close();
              this.popup = null;
            }
            this.$store.commit("auth/logOut");
            this.error = "This email cannot be used for payment";
            throw new Error("This email cannot be used for payment");
          }
          if (this.$store.getters["auth/userStatus"] !== 1) {
            if (this.popup) {
              this.popup.focus();
              this.popup.close();
              this.popup = null;
            }
            this.$store.commit("auth/logOut");
            this.error = "Please, confirm your email";
            throw new Error("Please, confirm your email");
          }
          if (!Object.values(this.$store.getters["user/cart"]).length) {
            this.notifyParentWindow({
              type: "rocketfuel_get_cart",
            });
          }
          this.$store.dispatch(`user/${USER_TRACK_EVENTS}`, {
            moduleInfo: {
              current: "Login Magic Link",
              activity: "continue with email button clicked",
            },
          });
          this.$router.push({ name: "Payment" });
          this.$refs.loader.hide();
        } catch (e) {
          this.error = e?.response?.data?.message
            ? e.response.data.message
            : e.message;
          this.$refs.loader.hide();
        }
      });
    },
    doSigin() {
      this.$store.commit("auth/setUserEmail", this.email);
      this.$emit("offMagic", false);
    },
    async signInContinue(values) {
      this.error = ""; // Clear any previous errors
      this.$refs.loader.start();
      try {
        const { email } = values;
        if (email) {
          const resp = await this.m.auth.loginWithEmailOTP({ email });
          if (resp) {
            const token = `Bearer ${resp}`;
            await this.magicSIGN(token);
          }
        } else {
          this.$refs.loader.hide();
        }
      } catch (err) {
        const messages = err.message.split("]");
        this.error = messages.length > 1 ? messages[1] : messages[0];
        this.$refs.loader.hide();
      }
    },
    async render() {
      this.$refs.loader.start();
      if (this.$refs.loader) {
        this.$refs.loader.hide();
      }
    },
  },
  mounted() {
    this.syncEmailFromCart();
    this.render();
    this.$refs.loader.hide();
  },
};
</script>

<style lang="scss" scoped>
.cs-input .input-wrapper__input {
  width: 100%;
  padding: 10px;
  color: #1b1f3b;
  font-weight: 300;
  font-size: 14px;
  display: flex;
  align-items: center;
  border-radius: 4px;
  background-color: #fff;
  border: 1px solid #b2b7c5;
  letter-spacing: 0.04em;
  transition: 0.35s;
}

.cs-sign-in__toggle {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  background: #edf0f7;
  border-radius: 999px;
  padding: 3px;
  gap: 4px;
  border: 1px solid #d8dce6;
  margin-top: 12px;
}

.cs-sign-in__toggle--inputs {
  margin-top: 8px;
}

.cs-sign-in__toggle-btn {
  border: none;
  border-radius: 999px;
  background: transparent;
  padding: 8px 10px;
  font-size: 13px;
  font-weight: 600;
  color: #6e728b;
  cursor: pointer;
  transition: all 0.2s ease;

  &:focus {
    outline: none;
  }

  &.is-active {
    background: #ffffff;
    color: #1b1f3b;
    box-shadow: 0 3px 6px rgba(30, 36, 66, 0.16);
  }
}
</style>
